import * as mobx from 'mobx';
import { IAttendeeOrganizationDTO } from '../../../api/attendees.dao';
import { IConnectionOrganizationDTO } from '../../../api/connections.dao';
import { IRoomDetailsDTO } from '../../../api/rooms.dao';
import { ConnectionEntity } from '../abstract-connection.entity';

type PresenterType = { organizationId: number; name: string };
type EntityProps = {
    presenterRoleConnectionId?: number;
    presenters: IAttendeeOrganizationDTO[];
    roomId: number;
};

const key = 'presenterRoleConnectionId';

export class RoomPresentersConnectionsEntity extends ConnectionEntity<EntityProps> {
    public static filterPresenterProps(organization: IConnectionOrganizationDTO): Partial<IAttendeeOrganizationDTO> {
        return {
            organizationId: organization.organizationId,
            name: organization.name
        };
    }

    public static create(roomConnections: IRoomDetailsDTO): RoomPresentersConnectionsEntity {
        const entityProps = {
            roomId: roomConnections.roomId,
            presenterRoleConnectionId: roomConnections.presenterRoleConnectionId,
            presenters: roomConnections.presenters
        };

        return new RoomPresentersConnectionsEntity(entityProps);
    }

    public getId(): number { return this.getProps().roomId; }

    public toDTO(): EntityProps {
        const _dto = { ...this.getProps(), presenters: this.getPresenters() };

        if (this.hasAssignedConnection()) {
            _dto[key] = this.getAssignedConnection();
        } else {
            delete _dto[key];
        }

        return _dto as EntityProps;
    }

    @mobx.observable
    private [key]: {};
    @mobx.observable
    private presenters: {[id: number]: PresenterType } = {};

    private constructor({ presenterRoleConnectionId, presenters = [], ...rest }: EntityProps) {
        super(key, rest);

        if (presenterRoleConnectionId) this.assignConnection(presenterRoleConnectionId);

        presenters.forEach(function(presenter) {
            this[presenter.organizationId] = presenter;
        }, this.presenters);
    }

    @mobx.action
    public setPresenters(presenters: IConnectionOrganizationDTO[]): void {
        this.presenters = {};
        presenters.forEach(function(presenter) {
            this[presenter.organizationId] = RoomPresentersConnectionsEntity.filterPresenterProps(presenter);
        }, this.presenters);
    }

    @mobx.action
    public removePresenterById = (organizationId: number): void => {
        delete this.presenters[organizationId];
    };

    public getPresenters(): IAttendeeOrganizationDTO[] {
        return Object.values(this.presenters) as IAttendeeOrganizationDTO[];
    }

}
